module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeAQMAAAAB/jzhAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURQAAAP///6XZn90AAAABdFJOUwBA5thmAAAASklEQVQI12NgAAH7//8/QAisgBlEsDcACf4DQEL+AUgLSG39DyDx/w8DA+P/f0Bl//8Dlf3/38DA////AQb5//8fQA0FKyaWAAIA6yEndmKeankAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon_back.png
// module id = 3ivG
// module chunks = 1